
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderPaymentGrid extends Serenity.EntityGrid<OrderPaymentRow, any> {
        protected getColumnsKey() { return OrderPaymentColumns.columnsKey; }
        protected getDialogType() { return OrderPaymentDialog; }
        protected getIdProperty() { return OrderPaymentRow.idProperty; }
        protected getInsertPermission() { return OrderPaymentRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderPaymentRow.localTextPrefix; }
        protected getService() { return OrderPaymentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: OrderPaymentService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;

        }
    }
}